<template>
  <div
    class="thumb-box"
    :class="{ 'thumb-box--coming-soon' : isComingSoon, hasHover }"
  >
    <div class="thumb-box__coming-soon">
      <span>TÁ CHEGANDO!</span>
    </div>    

    <picture class="thumb-box__img embed-responsive embed-responsive-16by9">
      <img class="embed-responsive-item" v-lazy="thumb" />
    </picture>

    <slot />
  </div>
</template>

<script>
  export default {
    props: {
      thumb: { type: String, default: '' },
      hasHover: { type: Boolean, default: true },
      isComingSoon: { type: Boolean, default: false }
    }
  }
</script>

<style scoped lang="scss">
  .thumb-box {
    $p: &;
    
    position: relative;
    border-radius: 5px;

    &:before {
      content: '';
      position: absolute;
      bottom: -100%;
      opacity: 0;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(rgba(#000, .15), rgba(#000, .6));
      z-index: 1;
      transition: .5s all;
      border-radius: 8px;
    }
    
    &:after {
      opacity: 0;
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-image: url('~@/assets/img/sprite.png');
      width: 64px;
      height: 64px;
      background-position: -36px 0;
      z-index: 2;
      transition: .5s all;
    }

    &__img { border-radius: 8px }

    &.hasHover:hover {
      &:after { opacity: 1 }
      &:before { opacity: 1 }
    }

    &:not(&--coming-soon) &__coming-soon { display: none !important }

    &--coming-soon {
      #{$p}__coming-soon {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(#fff, .5);
        z-index: 2;

        span {
          background: rgba(#ff8000, .80);
          color: #fff;
          padding: 5px 10px;
          border-radius: 5px;
          font-weight: 700;
          font-size: 14px;
          box-shadow: 0 0 20px 2px rgba(#ff8000, .7);
        }
      }
    }
  }
</style>